import $ from 'jquery';
import * as core from 'modules/core';

export default function () {
  const $pushMenu = $('.navigation');
  const $deeper = $pushMenu.find('.deeper');
  const $back = $pushMenu.find('.back');
  const $levels = $pushMenu.find('.navigation__level:not(.default)');


  /**
   * Slide in the next deeper level
   * @param  {object} e Event object
   * @return {undefined}
   */
  const slideIn = function (e) {
    
    // Only prevent default and add classes on mobile
    if (!core.isMobileView()) return;

    e.preventDefault();

    // Find next level
    const $target = $(e.currentTarget); // .deeper
    const $levelToFade = $target.closest('.navigation__level'); // .level
    const $levelToSlideIn = $target.closest('li').children('.navigation__level'); // .level

    $levelToSlideIn.addClass('in');
    $levelToFade.addClass('cover display-cover'); // Display cover to distinguish levels
  };

  /**
   * Slide back to the upper level
   * @param  {object} e Event object
   * @return {undefined}
   */
  const slideOut = function (e) {
    // Only prevent default and add classes on mobile
    if (!core.isMobileView()) return;

    // Don't propagate swipe event, otherwise offcanvas
    // would close on every swipe
    e.preventDefault();
    e.stopPropagation();

    // Target is either the level itself (swipe) or the back button,
    // so we have to find the $level with different strategies in each case
    const $target = $(e.currentTarget); // .back
    const $levelToSlideOut = $target.closest('.navigation__level');
    const $levelToReveal = $levelToSlideOut.parent().closest('.navigation__level');

    // Make it go away
    $levelToSlideOut.removeClass('in');

    // Display the cover to visually distinguish the levels
    $levelToReveal.removeClass('cover');

    // Compatibility mode fallback, trigger event instantly
    if (core.getTransitionEndString() === 'transitionEndFallback') {
      $levelToReveal.trigger(core.getTransitionEndString());
    }

    /**
     * Hide the cover. If transitionend is not fired by
     * opacity, re-bind the event once and wait for opacity
     * to fire.
     * @param  {Object} e jQuery event object
     * @return {undefined}
     */
    const slideOut_transitionend = function (e) {
      e.stopPropagation();
      const $target = $(e.currentTarget);

      if (e.originalEvent.propertyName !== 'opacity') {
        $target.one(core.getTransitionEndString(), slideOut_transitionend);
        return;
      }

      $target.removeClass('display-cover');
    };

    // Remove cover only when transition has ended
    $levelToReveal.one(core.getTransitionEndString(), slideOut_transitionend);
  };

  // Register events
  $deeper.on('click touchend', slideIn);
  $back.on('click', slideOut);
  $levels.on('swipeleft', slideOut);

  // Prevent transitionend events on deeper links
  // from bubbling to .level
  $deeper.on(core.getTransitionEndString(), (e) => {
    e.stopPropagation();
  });
}



// WEBPACK FOOTER //
// ./BBZP/Frontend/js/modules/push-navigation.js